// extracted by mini-css-extract-plugin
export default {"panelCell":"NumberRangeOptimizerView_panelCell__RDbPP","panelStack":"NumberRangeOptimizerView_panelStack__G0d-X","panelButton":"NumberRangeOptimizerView_panelButton__2nYoo"};